<template>
  <button
    @mouseover="$emit('mouseover')"
    @mouseleave="$emit('mouseleave')"
    :class="buttonClass"
    :disabled="disabled"
    @click="emitClick"
  >
    <img class="icon" v-if="icon" :src="`/icons/${icon}.svg`" alt="" />
    <slot></slot>
  </button>
</template>

<style scoped>
.dashboard-button {
  display: block;
  padding: 0.888vh 1.6vh;
  text-align: center;
  border: 0.111vh solid transparent;
  outline: none;
  -webkit-appearance: none;
  cursor: pointer;
  border-radius: 0.444vh;
  font-size: 1.6vh;
  line-height: 1.777vh;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.button-variant-standart {
  background: transparent;
  border-color: #ededed;
  color: #ededed;
}
.button-variant-standart:disabled {
  background: #908f8d;
  border-color: #908f8d;
  color: #ededed;
}
.button-variant-white {
  color: #908f8d;
  background: transparent;
  border: 0.111vh solid #908f8d;
}
.button-variant-white:hover {
  color: #1d1d1b;
  background: #ededed;
  border: 0.111vh solid #ededed;
}
.button-variant-primary {
  color: #ededed;
  background: transparent;
  border: 0.111vh solid #ededed;
}

.button-variant-primary:hover {
  color: #ededed;
  background: #129b81;
  border: 0.111vh solid transparent;
}
.button-variant-black {
  color: #1d1d1b;
  background: transparent;
  border: 0.111vh solid #1d1d1b;
}
.button-variant-black:hover {
  color: #ededed;
  background: #129b81;
  border: 0.111vh solid transparent;
}
.button-variant-black-fill {
  color: #ededed;
  background: #1d1d1b;
  border: 0.111vh solid #1d1d1b;
}
.button-variant-delivery {
  color: #1d1d1b;
  background: #cbd9e6;
  border: 0.111vh solid #cbd9e6;
}
.button-variant-preorder {
  color: #1d1d1b;
  background: #ffd2a8;
  border: 0.111vh solid #ffd2a8;
}
.button-variant-reserve {
  color: #1d1d1b;
  background: #aeccc6;
  border: 0.111vh solid #aeccc6;
}
.button-variant-primary:disabled {
  color: #908f8d;
  border: 0.111vh solid #908f8d;
  cursor: not-allowed;
  background: transparent;
}

.button-variant-danger {
  color: #e2223b;
  background: transparent;
  border: 0.111vh solid #e2223b;
}

.button-variant-danger:hover {
  color: #ededed;
  background: #e2223b;
  border: 0.111vh solid transparent;
}


.button-variant-danger-fill {
  color: #ededed;
  background: #e2223b;
  border: 0.111vh solid #e2223b;
}

.button-variant-danger:disabled {
  color: #908f8d;
  border: 0.111vh solid #908f8d;
  cursor: not-allowed;
  background: transparent;
}

.button-variant-success {
  color: #129b81;
  background: transparent;
  border: 0.111vh solid #129b81;
}

.button-variant-success:hover {
  color: #ededed;
  background: #129b81;
  border: 0.111vh solid transparent;
}

.button-variant-success:disabled {
  color: #908f8d;
  border: 0.111vh solid #908f8d;
  cursor: not-allowed;
  background: transparent;
}

.button-variant-success-fill {
  color: #ededed;
  background: #129b81;
  border: 0.111vh solid #129b81;
}

.button-variant-success-fill:hover {
  color: #ededed;
  background: #129b81;
  border: 0.111vh solid transparent;
}

.button-variant-success-fill:disabled {
  color: #908f8d;
  border: 0.111vh solid #908f8d;
  cursor: not-allowed;
  background: transparent;
}
.button-variant-edit {
  color: #129b81;
  border: 0.111vh solid #129b81;
  background: transparent;
}
.button-variant-edit-black {
  color: #1d1d1b;
  border: 0.111vh solid #1d1d1b;
  background: transparent;
}
.button-variant-copy {
  color: #416293;
  border: 0.111vh solid #416293;
  background: transparent;
}
.button-variant-delete {
  color: #e2223b;
  border: 0.111vh solid #e2223b;
  background: transparent;
}
.button-variant-moeco {
  background: #5395ff;
  color: #ededed;
  border: 0.111vh solid #5395ff;
}
.button-wide {
  width: 100%;
}
.icon {
  width: 1.5555vh;
  height: 1.5555vh;
  margin-right: 1.11111vh;
}
</style>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
  },
  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
  computed: {
    buttonClass() {
      return {
        "dashboard-button": true,
        [`button-variant-${this.variant}`]: true,
        "button-wide": this.wide,
      };
    },
  },
};
</script>
